// extracted by mini-css-extract-plugin
export var contentBody = "_aq-9";
export var headerImage = "_aq-2";
export var imageButton = "_aq-7";
export var imageButtonIcon = "_aq-8";
export var imageHeader = "_aq-4";
export var imageHeaderText = "_aq-5";
export var imageOverlay = "_aq-3";
export var imageTitle = "_aq-6";
export var imageWrapper = "_aq-1";
export var taskList = "_aq-a";
export var widget = "_aq-0";